import React from 'react';

import {
  AutocompleteInput,
  ReferenceInput,
  ReferenceInputProps,
  required,
} from 'react-admin';

interface AutocompleteLocationInputProps
  extends Omit<ReferenceInputProps, 'reference' | 'filterToQuery'> {
  clientId?: string;
  isRequired?: boolean;
}

const AutocompleteLocationInput: React.FC<AutocompleteLocationInputProps> = ({
  source,
  label,
  filter,
  clientId,
  isRequired,
  disabled,
  ...props
}) => {
  // render disabled input if no clientId is provided
  if (!clientId) {
    return (
      <AutocompleteInput
        source={source}
        label={label}
        choices={[]}
        disabled={true}
        helperText="Please select a client first"
      />
    );
  }

  return (
    <ReferenceInput
      {...props}
      source={source}
      filter={{ ...filter, clientIds: [clientId] }}
      reference="CoachLocation"
      filterToQuery={(name: string) => ({
        name,
      })}
    >
      <AutocompleteInput
        optionText="name"
        filter="name"
        label={label}
        isRequired={isRequired}
        validate={isRequired ? required('Location is required') : undefined}
        noOptionsText="No locations available for this client"
        disabled={disabled}
      />
    </ReferenceInput>
  );
};

export default AutocompleteLocationInput;
